import {useCurrentRepository} from '@github-ui/current-repository'
// eslint-disable-next-line import/no-deprecated
import {useVerifiedFetch} from '@github-ui/use-verified-fetch'
import {GitCompareIcon, KebabHorizontalIcon, SyncIcon} from '@primer/octicons-react'
import {ActionList, ActionMenu, IconButton} from '@primer/react'
import {useState} from 'react'

import {compareButtonHref} from '../helpers/compare-button-href'
import {useActivityAnalytics} from '../hooks/use-activity-analytics'
import type {Push} from '../types/activity-types'
import styles from './ActivityOverflowMenu.module.css'

export function ActivityOverflowMenu({push}: {push: Push}) {
  const repo = useCurrentRepository()
  const href = compareButtonHref(push, repo)

  // eslint-disable-next-line import/no-deprecated
  const restoreBranch = useVerifiedFetch<void>(push.restoreUrl !== null ? push.restoreUrl : '', 'post')
  const [isRestoring, setIsRestoring] = useState(false)

  const onRestoreBranch = async () => {
    sendActivityClickEvent('OVERFLOW_MENU.RESTORE_BRANCH')
    if (push.restoreUrl !== null) {
      setIsRestoring(true)
      await restoreBranch()
      setTimeout(() => {
        window.location.reload()
        setIsRestoring(false)
      }, 500)
    }
  }

  const {sendActivityClickEvent} = useActivityAnalytics()

  return (
    <ActionMenu onOpenChange={open => open && sendActivityClickEvent('OVERFLOW_MENU')}>
      <ActionMenu.Anchor>
        <IconButton
          className={styles.menuButton}
          icon={KebabHorizontalIcon}
          variant="invisible"
          aria-label="More activity actions"
          title="More activity actions"
        />
      </ActionMenu.Anchor>

      <ActionMenu.Overlay>
        <ActionList>
          <ActionList.LinkItem onClick={() => sendActivityClickEvent('OVERFLOW_MENU.COMPARE')} href={href}>
            <ActionList.LeadingVisual>
              <GitCompareIcon />
            </ActionList.LeadingVisual>
            Compare changes
          </ActionList.LinkItem>
          {push.restoreUrl && (
            <ActionList.Item onSelect={onRestoreBranch} disabled={isRestoring}>
              <ActionList.LeadingVisual>
                <SyncIcon />
              </ActionList.LeadingVisual>
              Restore branch
            </ActionList.Item>
          )}
        </ActionList>
      </ActionMenu.Overlay>
    </ActionMenu>
  )
}
